import Vue from 'vue'
import VueRouter from 'vue-router'
import SchedulerView from '../views/SchedulerView.vue'
import BookslotView from '../views/BookslotView.vue'
import NotFoundView from '../views/NotFoundView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/scheduler',
    name: 'scheduler',
    component: SchedulerView,
  },
  {
    path: '/book/:id/:slug',
    name: 'book',
    component: BookslotView,
  },
  {
    // Anything else (including "/" and partial /book URLs) gets a friendly
    // fallback instead of a blank page
    path: '*',
    name: 'not-found',
    component: NotFoundView,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
